import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { ContactFormModule } from './contact-form/contact-form.module';
import { ContactSectionComponent } from './contact-section.component';

@NgModule({
  declarations: [ContactSectionComponent],
  imports: [CommonModule, ContactFormModule, SharedComponentsModule],
  exports: [ContactSectionComponent]
})
export class ContactSectionModule {}
